module.exports = __webpack_public_path__ + "img/convenio_inamu2.362fdb67.jpg";